import {mapActions} from 'vuex';

import * as USER from '@/store/constants/user';
import * as DOCTOR from '@/store/constants/doctor';

import NotificationMixin from '@/mixins/notification';

import Notification from '@/views/Common/Notification';
import DoctorForm from '@/views/Doctor/DoctorAdd';

export default {
  inject: ['$validator'],
  name: "UserAdd",
  components: {
    DoctorForm, Notification
  },
  mixins: [NotificationMixin],
  data() {
    return {
      item: {
        api_token: null,
        role_id: null,
      },
      roles: {
        options: [{value: 1, text: 'admin'}, {value: 2, text: 'doctor'}, {text: 'staff', value: 3}]
      },
      isProcessing: false
    }
  },
  computed: {
    isDoctor() {
      return this.item.role_id === 2;
    }
  },
  methods: {
    ...mapActions({
      postUser: USER.ACTION_ADD,
      postDoctor: DOCTOR.ACTION_ADD
    }),

    saveDoctorData(userId) {
      if (this.isDoctor) {
        let doctorForm = this.$refs['doctor-form'].$data;
        doctorForm.doctor.user_id = userId;
        this.postDoctor(doctorForm.doctor)
      }
    },

    save() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.postUser(this.item).then((user) => {
              this.saveDoctorData(user.data.id);
              this.showSuccessNotification('User record successfully added.');
            })
            .catch((err) => this.showErrorNotification(err.response.data.message))
            .finally(() => this.isProcessing = false);
        }
      }).catch((e) => console.log(e));
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/User/js/add.js